export default "__VITE_ASSET__Dm7Lx5wS__"